import { FC, useState } from 'react'
import {
  AD_LIBRARY_FILTER_TABS,
  InsightCategory,
  SmartInsightsAIRecommendations,
} from 'src/charts/SmartInsightsAIRecommendations'
import { useGetAdsLibrarySmartInsightsQuery } from 'src/reactQuery/useGetAdsLibrarySmartInsightsQuery'
import { AdLibraryWidget } from './AdLibraryWidget'
import { CompetitorsComparison } from './CompetitorsComparison'
import { GoogleAdsComingSoonModal } from './GoogleAdsComingSoonModal'
import { MetaCoverageBanner } from './MetaCoverageBanner'
import { PlatformToggle } from './PlatformToggle'
import { SavedCompetitors } from './SavedCompetitors'
import { AdLibraryBreadcrumb } from '../Breadcrumb'
import classes from '../adLibrary.module.scss'

export const AdLibraryMain: FC = () => {
  const [googleModalOpen, setGoogleModalOpen] = useState(false)
  const { data: rawInsights, isLoading: smartInsightsLoading } =
    useGetAdsLibrarySmartInsightsQuery()

  const smartInsightsData = rawInsights
    ? {
        hasInsights: rawInsights.hasInsights,
        insights: rawInsights.insights?.map((i) => ({
          ...i,
          category: i.category as InsightCategory,
        })),
      }
    : undefined

  return (
    <div className={classes.container}>
      <div className={classes.topRow}>
        <AdLibraryBreadcrumb />
        {/* Meta is the only live provider; Google Ads opens a coming-soon
            modal and Meta stays selected. */}
        <PlatformToggle
          onChange={(platform) => {
            if (platform === 'google') setGoogleModalOpen(true)
          }}
          value="meta"
        />
      </div>

      <div className={classes.bannerRow}>
        <MetaCoverageBanner />
      </div>

      <div className={classes.content}>
        <AdLibraryWidget />
        <SavedCompetitors />
        <CompetitorsComparison />
        <SmartInsightsAIRecommendations
          data={smartInsightsData}
          filterTabs={AD_LIBRARY_FILTER_TABS}
          homePageVariant
          isLoading={smartInsightsLoading}
        />
      </div>

      <GoogleAdsComingSoonModal
        isOpen={googleModalOpen}
        onClose={() => setGoogleModalOpen(false)}
      />
    </div>
  )
}
